// Recovery for stale lazy-loaded chunks after a new deploy.
//
// When a new version deploys, JS files get new hashed names and the old ones
// stop existing on the server. A session that's already open then fails to
// dynamically import a lazy tab ("Failed to fetch dynamically imported module")
// and shows the error boundary. This helper reloads once to pull the fresh
// index.html + chunks. It is time-guarded so it can never loop (e.g. when the
// user is genuinely offline it reloads at most once every 10s, then gives up
// and lets the normal error UI show).

export function isChunkLoadError(err: unknown): boolean {
  const msg = (err as { message?: string } | null)?.message || String(err ?? '')
  return /dynamically imported module|module script failed|ChunkLoadError|Failed to fetch/i.test(msg)
}

export function reloadForChunkError(): void {
  try {
    const KEY = 'sb-chunk-reload-at'
    const last = Number(sessionStorage.getItem(KEY) || '0')
    if (Date.now() - last > 10000) {
      sessionStorage.setItem(KEY, String(Date.now()))
      window.location.reload()
    }
  } catch {
    window.location.reload()
  }
}
